import moment from "moment";
import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import LoadingModal from "../../components/shared/LoadingModal";
import GenericModal from "../../components/shared/GenericModal";
import { MdDone } from "react-icons/md";
import useBug from "../../hooks/useBug";

export default function BugReport() {
    const [category, setCategory] = useState<string>("");
    const [date, setDate] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [errorMsg, setErrorMsg] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDone, setIsDone] = useState<boolean>(false);

    const { goBack } = useHistory();
    const { createReport } = useBug();


    function isFormValid(): boolean {
        const validations: boolean[] = [
            category.length > 0,
            moment(date, 'YYYY-MM-DD').isValid(),
            description.length > 9
        ];

        return validations.every((validation) => validation);
    }

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        setIsLoading(true);
        setErrorMsg("");

        if (!isFormValid()) {
            setErrorMsg('Ocorreu um erro com os dados inseridos, por favor, verifique os dados inseridos e tente novamente.');
            setIsLoading(false);
            return;
        }

        const isCreated = await createReport({
            category,
            date,
            description
        });

        if (isCreated) {
            setIsDone(true);
        } else {
            setErrorMsg("Ocorreu um erro desconhecido ao processar sua requisição, por favor, tente novamente.")
        }

        setIsLoading(false);
    }

    function getTodayDate() {
        return moment().format('YYYY-MM-DD')
    }

    const availableCategories: string[] = [
        'Análises (Lucy AI)',
        'Conta',
        'Lentidão',
        'Assinatura',
        'Social',
        'Ativos',
        'Ranking',
        'Usuários',
        'Outros'
    ];

    if (isLoading) {
        return <LoadingModal />
    } else if (isDone) {
        return <GenericModal title="Tudo certo" description="Recebemos seu relato de problema, iremos analisar seu problema e realizar o máximo de esforços para corrigir, caso seja necessário entraremos em contato por e-mail. Muito obrigado por contribuir para evolução da plataforma." actions={[
            {
                title: 'Concluir',
                onClickHandler: () => goBack(),
                isLoading: false,
                variant: 'primary'
            }
        ]} icon={<MdDone size={50} color="#008A00" />} />
    }

    return <Modal show fullscreen size="lg" animation>
        <Modal.Header>
            <Modal.Title>Descreva seu problema</Modal.Title>
            <AiOutlineClose onClick={goBack} size={23} className="float-right cursor-pointer" />
        </Modal.Header>

        <Modal.Body>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label>Categoria <span className="tx-danger">*</span></Form.Label>
                    <Form.Select value={category} onChange={(e) => setCategory(e.target.value)} style={{ borderRadius: 10 }} required className="form-control select2-no-search select2-hidden-accessible wd-200">
                        <option value="">Selecione uma categoria</option>
                        {availableCategories.map((ct, i) => {
                            return <option key={i} value={ct}>{ct}</option>
                        })}
                    </Form.Select>
                </Form.Group>


                <Form.Group className="mb-3">
                    <Form.Label>Data do ocorrido <span className="tx-danger">*</span></Form.Label>
                    <Form.Control className="wd-200" value={date} onChange={((e) => setDate(e.target.value))} style={{ borderRadius: 10 }} required as="input" min={"2000-01-01"} max={getTodayDate()} placeholder="DD/MM/AAAA" type="date" />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Detalhes <span className="tx-danger">*</span></Form.Label>
                    <Form.Control value={description} onChange={(e) => setDescription(e.target.value)} required minLength={25} style={{ borderRadius: 10 }} as="textarea" placeholder="Descreva seu problema com o máximo de detalhes possível." rows={3} />
                </Form.Group>

                {errorMsg && <p className="tx-danger tx-center">
                    {errorMsg}
                </p>}

                <div className="centered-flex">
                    <Button className="rounded-button" variant="primary" type="submit">
                        Enviar
                    </Button>
                </div>
            </Form>
        </Modal.Body>
    </Modal>
}